import updateGlobalFolderViewState from '../services/updateGlobalFolderViewState';
import OwaViewStateConfiguration from 'owa-service/lib/contract/OwaViewStateConfiguration';
import UserOptionsType from 'owa-service/lib/contract/UserOptionsType';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { action, select } from 'satcheljs/lib/legacy';
import {
    MAX_LIST_VIEW_WIDTH,
    MIN_LIST_VIEW_WIDTH,
    MAX_LIST_VIEW_HEIGHT,
    MIN_LIST_VIEW_HEIGHT,
} from 'owa-mail-list-dimensions';

export interface SetListViewSizeState {
    userOptions: UserOptionsType;
    viewStateConfiguration: OwaViewStateConfiguration;
}

export default action('setListViewDimension')(
    select({
        userOptions: () => getUserConfiguration().UserOptions,
        viewStateConfiguration: () => getUserConfiguration().ViewStateConfiguration,
    })(function setListViewDimension(
        listViewDimension: number,
        isWidth: boolean,
        state?: SetListViewSizeState
    ) {
        // We limit the list view dimension between min and max dimensions allowed
        let listViewDimensionToStore = listViewDimension;
        const maxDimension = isWidth ? MAX_LIST_VIEW_WIDTH : MAX_LIST_VIEW_HEIGHT;
        const minDimension = isWidth ? MIN_LIST_VIEW_WIDTH : MIN_LIST_VIEW_HEIGHT;
        if (listViewDimension > maxDimension) {
            listViewDimensionToStore = maxDimension;
        } else if (listViewDimension < minDimension) {
            listViewDimensionToStore = minDimension;
        }

        const globalFolderViewState: any = JSON.parse(
            state.viewStateConfiguration.GlobalFolderViewState || '{}'
        );

        if (isWidth) {
            globalFolderViewState.Width = listViewDimensionToStore;
        } else {
            globalFolderViewState.Height = listViewDimensionToStore;
        }

        state.viewStateConfiguration.GlobalFolderViewState = JSON.stringify(globalFolderViewState);

        updateGlobalFolderViewState();
    })
);
